import React from 'react'
import Reflux from 'reflux'
import Store from '../../../store/store'
import i18 from '../../../i18'
import api from '../../../source/api'
import RuleViewModal from "../Rules/RuleViewModal";
import AssignmentRuleCreate from "./AssignmentRuleCreate";

class Assignment extends Reflux.Component {

    constructor(props) {
        super(props)
        this.state = {
            config: props.config,
            vatCollectorCodes: props.vatCollectorCodes,
            invoices: props.invoices,
            customerRules: props.customerRules,

            processing: false,
            showProcessedItems: false,
            processedCount: 0,
            modalIsOpen: false,
            showRule: null,
        }
        this.store = Store
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            invoices: nextProps.invoices,
            customerRules: nextProps.customerRules,
        })
    }

    createRule = (rule) => {
        api.post('customer/' + this.state.config.company_id + '/rule/add', rule)
            .then((response) => {
                this.props.notifySuccess('Szabály sikeresen mentve.')
                this.props.updateRules(response.data.customerRules);
            })
            .catch((error) => {
                if (error.response && error.response.status === 422) {
                    this.props.notifyError(error.response.data.message)
                    return;
                }

                this.props.notifyError('Hiba történt a szabály létrehozása során. (#1002)')
            })
    }

    showHideProcessedItems = () => {
        this.setState({showProcessedItems: !this.state.showProcessedItems})
    }

    getListHeaderRow() {
        return <tr>
            <th>{i18.CUSTOMER._typeOfTraffic}</th>
            <th>{i18.CUSTOMER._mainBookNumber}</th>
            <th>{i18.CUSTOMER._VAT}</th>
            <th>{i18.CUSTOMER._collectorCode}</th>
            <th>{i18.CUSTOMER._taxNumber}</th>
            <th>{i18.CUSTOMER._companyName}</th>
            <th>{i18.CUSTOMER._paymentType}</th>
            {this.state.config.positionNumberVisible
                ? <React.Fragment>
                    <th>{i18.CUSTOMER._positionNumber}</th>
                    <th>{i18.CUSTOMER._positionNumberCountry}</th>
                </React.Fragment>
                : null
            }
            <th>{i18.CUSTOMER._invoiceNumber}</th>
            <th>{i18.CUSTOMER._vatDegreeNumber}</th>
            <th>&nbsp;</th>
        </tr>
    }

    renderProcessedTableHeader() {
        return <tr>
            <th>{i18.COMPANY._operations}</th>
            <th>{i18.CUSTOMER._typeOfTraffic}</th>
            <th>{i18.CUSTOMER._mainBookNumber}</th>
            <th>{i18.CUSTOMER._VAT}</th>
            <th>{i18.CUSTOMER._collectorCode}</th>
            <th>{i18.CUSTOMER._taxNumber}</th>
            <th>{i18.CUSTOMER._companyName}</th>
            <th>{i18.CUSTOMER._paymentType}</th>
            {this.state.config.positionNumberVisible
                ? <React.Fragment>
                    <th>{i18.CUSTOMER._positionNumber}</th>
                    <th>{i18.CUSTOMER._positionNumberCountry}</th>
                </React.Fragment>
                : null
            }
            <th>{i18.CUSTOMER._invoiceNumber}</th>
            <th>{i18.CUSTOMER._vatDegreeNumber}</th>
        </tr>
    }


    renderProcessedTableRows = () => {
        let invoices = [];
        for (let index in this.state.invoices) {
            let invoice = this.state.invoices[index]
            for (let itemIndex in invoice.items) {
                let invoiceItem = invoice.items[itemIndex];
                if (!invoiceItem.rule_id) {
                    continue;
                }

                let rule = this.state.customerRules.find(x => x.id === invoiceItem.rule_id);
                invoices.push(
                    this.renderProcessedTableRow(invoice, invoiceItem, rule)
                );
            }
        }

        return invoices
    }

    renderProcessedTableRow(invoice, invoiceItem, rule) {
        return (
            <tr>
                <td>
                    <button type="button" className="table-green-btn" onClick={(event) => this.onShowRule(event)}>
                        #{invoiceItem.rule_id}
                    </button>
                </td>
                <td>{invoiceItem.name}</td>
                <td>{rule.main_bookkeeping_number}</td>
                <td>{parseInt(invoiceItem.vat, 0)}%</td>
                <td>{rule.vatCollectorCode ? rule.vatCollectorCode.code : null}</td>
                <td>{invoice.tax_number}</td>
                <td>{invoice.company_name}</td>
                <td>{invoice.paymentMethodLabel}</td>
                {this.state.config.positionNumberVisible
                    ? <React.Fragment>
                        <td>{invoice.positionNumber}</td>
                        <td>{invoice.positionNumberCountry}</td>
                    </React.Fragment>
                    : null
                }
                <td>{invoice.invoiceNumber}</td>
                <td>{rule.vat_degree}</td>
            </tr>
        )
    }

    getUnprocessedInvoices = () => {
        let invoices = [];

        for (let index in this.state.invoices) {
            let invoice = this.state.invoices[index]
            for (let itemIndex in invoice.items) {
                let invoiceItem = invoice.items[itemIndex];
                if (invoiceItem.rule_id) {
                    continue;
                }

                invoices.push(
                    <AssignmentRuleCreate
                        key={'unprocessed' - index + '-' + itemIndex + '-' + Math.random(9999, 99999)}
                        config={this.state.config}
                        vatCollectorCodes={this.state.vatCollectorCodes}
                        invoice={invoice}
                        invoiceItem={invoiceItem}

                        createRule={(rule) => this.createRule(rule)}
                        notifySuccess={(msg) => this.props.notifySuccess(msg)}
                        notifyError={(msg) => this.props.notifyError(msg)}
                    />
                );
            }
        }

        return invoices
    }

    onShowRule = (rule) => {
        this.setState({showRule: rule})
    };

    closeModal = () => {
        this.setState({showRule: null})
    };

    render = () => {
        return (
            <section id='customer-assignment' className='margin-bottom-50'>

                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <ul className='legend'>
                                <li><i className='fa fa-dot-circle-o' aria-hidden='true'/> <span className=''>{i18.CUSTOMER._createRulesAndProcess}</span></li>
                                <li><i className='padding-left-20 fa fa-check-circle' aria-hidden='true'/> <span className=''>{i18.CUSTOMER._oneTimeProcessing}</span></li>
                            </ul>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <p>Szabályok súlyozásához a szabály elé kell írni '#' jelet és egy számot. Pl: "#3Előleg levonása", "#8Előleg".</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <table className='table table-striped table-aibook-no-border'>
                                <thead>
                                {this.getListHeaderRow()}
                                </thead>
                                <tbody>
                                {this.getUnprocessedInvoices()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='row margin-bottom-50'>
                        <div className='col-12'>
                            <div className='next-step-btn-container'>
                                <a onClick={() => this.props.nextStep()} className={this.state.processing ? 'disabled next-step pull-right' : 'next-step pull-right'}>Feldolgozás</a>
                                <a onClick={() => this.showHideProcessedItems()} className='next-step pull-left'>Feldolgozott tételek</a>
                            </div>
                        </div>
                    </div>
                    <div className={this.state.showProcessedItems ? '' : 'd-none'}>
                        <table className='table table-striped table-aibook-no-border'>
                            <thead>
                            {this.renderProcessedTableHeader()}
                            </thead>
                            <tbody>
                            {this.renderProcessedTableRows()}
                            </tbody>
                        </table>
                    </div>
                </div>
                {this.state.showRule
                    ? <RuleViewModal
                        config={this.state.config}
                        rule={this.state.showRule}
                        closeModal={() => this.closeModal()}
                    />
                    : null
                }
            </section>
        )
    }
}

export default Assignment


// WEBPACK FOOTER //
// ./src/components/customer/Steps/Assignment.js